<template>
  <div class="pt-1 w-[50dvw]">
    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <div class="w-full flex items-center gap-3">
        <placeholder class="w-1/2" :field="field" />
        <field-filled-by class="w-1/2 pb-1" :field="field" />
      </div>
      <div class="flex items-center gap-3 pt-1 w-full">
        <div class="w-1/2">
          <el-form-item>
            <div class="flex flex-col gap-1.5">
              <label
                for=""
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Prefix
              </label>
              <el-input placeholder="Prefix" v-model="field.auto_increment_prefix"></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="w-1/2">
          <el-form-item>
            <div class="flex flex-col gap-1.5">
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                for=""
              >
                Length of Characters
              </label>
              <el-input-number
                type="number"
                :min="getMinValue()"
                v-model="field.random_text_length"
                placeholder="No of characters"
              ></el-input-number>
            </div>
          </el-form-item>
        </div>
      </div>

      <div>
        <el-col :span="10">
          <el-form-item>
            <label
              class="field-title-label text-black-600 !text-xs 2xl:!text-sm font-normal !pb-2 w-full"
              for=""
            >
              Choose your preferences
              <span class="text-red-500">*</span>
            </label>
            <br />
            <el-checkbox-group v-model="field.selected_preferences">
              <div class="checkbox-container">
                <el-checkbox v-for="option in availableOptions" :label="option" :key="option">
                  {{ option }}
                </el-checkbox>
              </div>
            </el-checkbox-group>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-checkbox v-model="field.properties.allow_to_regenerate">
                    Allow to regenerate
                  </el-checkbox>
                </el-col>
              </el-row>
            </el-col>
          </el-form-item>
        </el-col>
      </div>
      <div class="flex items-center justify-center gap-6 pt-1">
        <div class="icon-dropdown-selection flex items-center !gap-3">
          <span
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Icon
          </span>
          <el-button type="text" @click="iconPickerdialogVisible = true" class="">
            <div class="d-flex align-center menu-icon !gap-2">
              <span>
                <icons :iconName="templateIconPath"></icons>
              </span>
              <i class="el-icon-circle-plus !text-brand-500"></i>
            </div>
          </el-button>
        </div>
        <is-field-required :field="field" class="field-required" />
      </div>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-SingleLineText',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
    },

    props: ['field', 'fieldsData'],
    mounted() {
      console.log('random text', this.field);
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
    },
    data() {
      return {
        checkAll: false,
        availableOptions: [
          'Use Letters',
          'Use non capitalized',
          'Use Numbers',
          'Use Special Characters',
        ],
        iconPickerdialogVisible: false,
        templateIconPath: 'dashboard',
      };
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      getMinValue() {
        let min = 5;
        switch (this.field.selected_preferences.length) {
          case 1:
            min = 8;
            break;
          case 2:
            min = 6;
            break;
        }
        this.field.random_text_length = min;
        return min;
      },
    },
  };
</script>

<style lang="scss">
  .checkbox-container {
    display: flex;
    flex-direction: column;
  }

  .el-checkbox {
    align-items: center;
  }
</style>
